import React, { useState, useEffect } from "react";
import axios from "axios";
import { FaChevronLeft, FaChevronRight, FaUserAstronaut, FaExclamationCircle } from "react-icons/fa";
import Header from "../header/header";
import Footer from "../footer/footer";
import "./MyFollowing.css";

const CARDS_PER_PAGE = 6;

const formatDate = (dateString) => {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};

const MyFollowingPage = () => {
  const [followers, setFollowers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [listPage, setListPage] = useState(1);

  useEffect(() => {
    const fetchFollowing = async () => {
      try {
        const customerId = localStorage.getItem("customerId") || "1238";
        const response = await axios.get(
          `https://heastro.in/heastro-service/astro/followers/list/${customerId}`
        );
        setFollowers(response.data);
      } catch (error) {
        console.error("Error fetching following:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchFollowing();
  }, []);

  const totalPages = Math.ceil(followers.length / CARDS_PER_PAGE);
  const paginatedData = followers.slice(
    (listPage - 1) * CARDS_PER_PAGE,
    listPage * CARDS_PER_PAGE
  );

  return (
    <div className="fol-page-container">
      <Header />
      <div className="fol-wrapper">
        <div className="fol-hero-section">
          <h1 className="fol-cinzel-font">
            <span className="fol-maroon">MY FOLLOWING</span>
          </h1>
          <p className="fol-desc">
            Astrologers you follow — consult them anytime.
          </p>
        </div>

        {/* Mobile Stats */}
        <div className="fol-stats-mobile">
          <div className="fol-stats-inner">
            <div className="fol-stat-unit">
              <h3>{followers.length}</h3>
              <p>FOLLOWING</p>
            </div>
            <div className="fol-stat-divider" />
            <div className="fol-stat-unit fol-support-mobile">
              <span className="fol-dot-green" />
              <p>24/7 Support</p>
            </div>
          </div>
        </div>

        <div className="fol-layout-grid">
          {/* Main List */}
          <main className="fol-main-list">
            <div className="fol-area-header">
              <span className="fol-current-label">ALL FOLLOWING</span>
              <span className="fol-count">
                {followers.length}
                Results
              </span>
            </div>

            {loading ? (
              <div className="fol-loader">
                Fetching your cosmic connections...
              </div>
            ) : followers.length === 0 ? (
              <div className="fol-empty">
                <FaExclamationCircle className="fol-empty-icon" />
                <p style={{ color: "black" }}>
                  You are not following any astrologer yet.
                </p>
              </div>
            ) : (
              <>
                <div className="fol-compact-grid">
                  {paginatedData.map((follower, index) => (
                    <div key={index} className="fol-compact-card">
                      <div className="fol-card-top">
                        <div className="fol-astro-profile">
                          <div className="fol-img-box">
                            <img
                              src={
                                follower.astroPhotoUrlpath &&
                                follower.astroPhotoUrlpath !== "NA" &&
                                follower.astroPhotoUrlpath !== ""
                                  ? follower.astroPhotoUrlpath
                                  : "https://heastro.in/heastro-service/assets/cust.png"
                              }
                              alt={follower.astrologerName}
                              onError={(e) => {
                                e.target.src =
                                  "https://heastro.in/heastro-service/assets/cust.png";
                              }}
                            />
                            <span className="fol-type-icon">
                              <FaUserAstronaut />
                            </span>
                          </div>
                          <div className="fol-name-meta">
                            <p className="fol-astro-name">
                              {follower.astrologerName
                                ? follower.astrologerName
                                    .split(" ")
                                    .map(
                                      (w) =>
                                        w.charAt(0).toUpperCase() + w.slice(1),
                                    )
                                    .join(" ")
                                : ""}
                            </p>
                          </div>
                        </div>
                        <div className="fol-status-meta">
                          <span className="fol-pill-green">Following</span>
                        </div>
                      </div>

                      <div className="fol-card-bottom">
                        <div className="fol-meta-data">
                          <div>
                            <label>FOLLOWED SINCE</label>
                            <p>
                              {follower.followDate
                                ? formatDate(follower.followDate)
                                : "—"}
                            </p>
                          </div>
                          <div>
                            <label>ASTROLOGER ID</label>
                            <p>#{follower.astrologerId}</p>
                          </div>
                        </div>
                        {/* <button
                          className="fol-view-link"
                          onClick={() =>
                            (window.location.href = `/inquary/${follower.astrologerId}`)
                          }
                        >
                          VIEW PROFILE →
                        </button> */}
                        <div className="fol-action-btns">
                          <button
                            className="fol-chat-btn"
                            onClick={() =>
                              (window.location.href = `/chat-with-astrologer`)
                            }
                          >
                            💬 Chat
                          </button>
                          <button
                            className="fol-call-btn"
                            onClick={() =>
                              (window.location.href = `/call-with-astrologer`)
                            }
                          >
                            📞 Call
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                {totalPages > 1 && (
                  <div className="fol-list-pagination">
                    <button
                      className="fol-pag-btn"
                      disabled={listPage === 1}
                      onClick={() => setListPage((p) => p - 1)}
                    >
                      <FaChevronLeft /> Prev
                    </button>
                    <div className="fol-page-numbers">
                      {Array.from({ length: totalPages }, (_, i) => i + 1).map(
                        (n) => (
                          <button
                            key={n}
                            className={`fol-page-num ${listPage === n ? "active" : ""}`}
                            onClick={() => setListPage(n)}
                          >
                            {n}
                          </button>
                        ),
                      )}
                    </div>
                    <button
                      className="fol-pag-btn"
                      disabled={listPage === totalPages}
                      onClick={() => setListPage((p) => p + 1)}
                    >
                      Next <FaChevronRight />
                    </button>
                  </div>
                )}
              </>
            )}
          </main>

          {/* Desktop Stats Panel */}
          <div className="fol-stats-panel">
            <div className="fol-black-card">
              <label className="fol-stats-head">QUICK STATS</label>
              <div className="fol-stats-flex">
                <div className="fol-stat-unit">
                  <h3>{followers.length}</h3>
                  <p>FOLLOWING</p>
                </div>
              </div>
              <div className="fol-support-txt">
                <span className="fol-dot-green"></span> Support Available 24/7
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default MyFollowingPage;